import {toAmount} from '../services/billingService.js';
// Legacy check-ins recorded money only in register columns. Add virtual receipts for
// reporting without rewriting history; real receipts take precedence per stay.
export function withLegacyReceiptFallbacks(entries = []) {
  const additions=[];
  const checkInReceipts=new Set(entries.filter(entry=>entry.category==='checkin_guest_payment').map(entry=>entry.stayId));
  for(const entry of entries) {
    if(entry.entryType==='revenue'&&entry.category==='room'&&entry.ledgerCheckIn!=='CNU'&&!String(entry.operationId || '').startsWith('CNU_')&&!checkInReceipts.has(entry.stayId)) {
      const source=entries.find(item=>item.stayId===entry.stayId&&item.category==='source_prepaid');
      const sourceMode=String(source?.paymentMode || '').trim().toLowerCase();
      const sourceOnline=['ota','online travel agency'].includes(sourceMode)?toAmount(source.amount):0;
      const values=[['Cash',toAmount(entry.ledgerCash)],['UPI',Math.max(0,toAmount(entry.ledgerOnline)-sourceOnline)],
        ['Fab',source?0:toAmount(entry.ledgerFab)],['Brevistay',source?0:toAmount(entry.ledgerBrevistay)]];
      for(const [paymentMode,amount] of values) if(amount>0)additions.push({...entry,id:`legacy_${entry.id || entry.stayId}_${paymentMode}`,entryType:'payment',category:'legacy_checkin_receipt',amount,paymentMode,virtual:true});
    }
    if(entry.category==='checkin_excess_received'&&!checkInReceipts.has(entry.stayId)) {
      const source=entries.find(item=>item.stayId===entry.stayId&&item.category==='source_prepaid'&&item.paymentMode===entry.paymentMode);
      if(!source)additions.push({...entry,entryType:'payment',category:'legacy_excess_receipt',virtual:true});
    }
  }
  return [...entries,...additions];
}
